import { InputWithError, LoadingSpinner } from 'components/validation/InputWithError ';
import { useLogin } from 'features/auth/use-cases';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LoginFormValues } from './types';

export const LoginForm = () => {
  const { mutate, isLoading } = useLogin();
  const { t } = useTranslation();

  const [formValues, setFormValues] = useState<LoginFormValues>({
    userName: '',
    password: '',
    remember: false,
  });

  const [errors, setErrors] = useState<{ userName?: string; password?: string }>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const newErrors: { userName?: string; password?: string } = {};
    if (!formValues.userName?.trim()) newErrors.userName = 'Username is required.';
    if (!formValues.password?.trim()) newErrors.password = 'Password is required.';
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      mutate({
        userName: formValues.userName,
        password: formValues.password,
        persistSession: formValues.remember,
      } as any);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <InputWithError
        label={"Email / Username "}
        name="userName" // ✅ fixed: match state
        value={formValues.userName}
        onChange={handleChange}
        placeholder={"Enter Email or Username"}
        error={errors.userName}
      />

      <InputWithError
        label={t('login.formFields.password.label')}
        name="password"
        type="password"
        value={formValues.password}
        onChange={handleChange}
        placeholder={t('login.formFields.password.placeholder')}
        error={errors.password}
      />

      <button
        type="submit"
        disabled={isLoading}
        className="w-full flex items-center justify-center gap-2 ant-btn-primary text-white py-2 rounded-md hover:bg-sky-900 transition"
      >
        {isLoading && <LoadingSpinner />}
        {isLoading ? 'Processing' : 'Login'}
      </button>
    </form>
  );
};
